<div class="status">
  <div class="color" [ngClass]="color"></div>
  {{ text }}
</div>